import { Flex, HStack, Text } from '@chakra-ui/react'
import useTranslation from 'next-translate/useTranslation'

import { YEARLY_DISCOUNT } from 'constants/subscription'
import { useRegion } from 'providers/RegionProvider'
import { getLocaleFormattedPrice } from 'utils/price'

type Props = {
  price: number
  isYearlyPeriod?: boolean
}

export const SubscriptionPrice = ({ isYearlyPeriod, price }: Props) => {
  const { t } = useTranslation('common')
  const { region } = useRegion()

  if (!isYearlyPeriod || YEARLY_DISCOUNT === 0) {
    return (
      <HStack h="40px" mt="20px" spacing="12px" align="baseline">
        <Flex animation="fadeInLeft 600ms ease-out" key="computedPrice">
          <Text
            w="full"
            fontSize="28px"
            lineHeight="20px"
            fontWeight={600}
            color="brand.americanBlue"
          >
            {getLocaleFormattedPrice({
              price,
              region,
            })}
          </Text>
          <Text fontSize="16px" fontWeight={400} color="brand.americanBlue">
            /{t(isYearlyPeriod ? 'year' : 'month')}
          </Text>
        </Flex>
      </HStack>
    )
  }

  const computedPricePerMonth = Math.ceil(price / 12)
  const computedNonDiscountedPricePerMonth = Math.ceil(
    computedPricePerMonth / (1 - YEARLY_DISCOUNT / 100)
  )

  return (
    <HStack h="40px" mt="20px" spacing="12px" align="baseline">
      <Flex
        gap="4px"
        animation="fadeInLeft 600ms ease-out"
        key="computedPricePerMonth"
      >
        <Text
          w="full"
          fontSize="28px"
          lineHeight="20px"
          fontWeight={600}
          color="brand.ultramarine"
        >
          {getLocaleFormattedPrice({
            price: computedPricePerMonth,
            region,
          })}
        </Text>
        <Flex alignItems="center">
          <Text
            decoration="line-through"
            fontSize="24px"
            fontWeight={400}
            color="brand.darkBlueGray"
          >
            {getLocaleFormattedPrice({
              price: computedNonDiscountedPricePerMonth,
              region,
            })}
          </Text>
          <Text fontSize="16px" fontWeight={400} color="brand.darkBlueGray">
            /{t('month')}
          </Text>
        </Flex>
      </Flex>
    </HStack>
  )
}
